/*--------------------------------------------------
Website by Websolute
--------------------------------------------------*/
'use strict';

(function ($) {

	const header = document.getElementById("myHeader");
	const sticky = header.offsetTop;
	let menu_open = false;
	var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) {
        return p.toString() === "[object SafariRemoteNotification]";
    })(!window['safari'] || safari.pushNotification),
    isIE11 = !!navigator.userAgent.match(/Trident.*rv[ :]*11\./),
    isMobile = false;

	function oldBrowsers() {
        if (isIE11 === true) {
            html.classList.add('msie');
        }
        if (isSafari === true) {
            html.classList.add('safari');
        }
    }

    //is Mobile
    window.mobileAndTabletCheck = function () {
        (function (a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
                isMobile = true
            }
        })(navigator.userAgent || navigator.vendor || window.opera);
    };

    mobileAndTabletCheck();

    // Sticky Head
	function stickyHeader() {
		if (window.pageYOffset > sticky) {
			header.classList.add("sticky");
		} else {
			header.classList.remove("sticky");
		}
	}

	// MENU Toggle
	function menuToggle() {
		if ($(window).width() >= 1025) {
			$(".has-submenu:first-of-type .child-submenu").addClass("active");
		} else {
			$('#menu').find('.child-submenu')
				.prepend('<li class="menu-go-back menu-item"><a href="#/"><img src="img/chevron-left-colored.svg" class="arrow" alt="Go Back"> Go Back</a></li>');
			$('.menu-go-back').click(function () {
				$(this).parent('.child-submenu').removeClass('active');
			});
		}
		$(window).width();
		$('.menu-tab').click(function () {
			if (menu_open === true) {
				$('body.open-menu').removeClass('open-menu');
				$('.menu-hide').removeClass('show');
				$('.menu-tab').removeClass('active');
				$('.has-submenu.menu-item-active').removeClass('menu-item-active');
				menu_open = false;
			} else {
				$('body').addClass('open-menu');
				$('.menu-hide').addClass('show');
				$('.menu-tab').addClass('active');
				$('#menu').find("li:first").addClass('menu-item-active');
				menu_open = true;
			}
		});

		$('.has-submenu > a').click(function () {
			$('.has-submenu.menu-item-active').removeClass('menu-item-active');
			$(this).parent('.has-submenu').addClass('menu-item-active');

			$('.child-submenu.active').removeClass('active');
			$(this).parent('.has-submenu').find('.child-submenu').addClass('active');
		});
	};

	// ACCORDION
	function accordionsElement(){
		if ($(window).width() >= 1025) {
			// $(".accordion-content:not(:first-of-type)").css("display", "none");
			$(".accordion-title").addClass("open");
			$(".js-accordion-title").click(function () {
				// $(".open").not(this).removeClass("open").next().slideUp(300);
				$(this).toggleClass("open").next().slideToggle(300);
			});
		} else {
			$('.accordion-title').addClass('without-after-element');
		}
	}

	// Hero sldier
	function heroSlider(){
		if ($('.thumbnail-slider-js').length){
		var thumbnailSlider = new Swiper('.thumbnail-slider-js', {
			autoplay: {
				delay: 4500,
				// disableOnInteraction: true
			},
			speed: 500,
			loop: true,
			slidesPerView: 1,
			spaceBetween: 20,
			fadeEffect: {crossFade: true},
			effect: "fade",

		});

		swiperThumbs(thumbnailSlider, {
			// Our default options
			element: 'swiper-thumbnails',
			activeClass: 'active-thumb',
			scope: '.thumbnail-wrapper-js' // Parent selector that surrounds your Swiper html & Swiper thumbnail html to support multiple Swiper instances on one page.
		});
	}
	}

	// Tabs
	function tabsElement(){
		// TABS
		$("#tabs-nav li:first-child").addClass("active");
		$(".tab-content").hide();
		$(".tab-content:first").show();


		// Click function
		$("#tabs-nav li").click(function () {
			$("#tabs-nav li").removeClass("active");
			$(this).addClass("active");
			$(".tab-content").hide();

			const activeTab = $(this).find("a").attr("href");
			$(activeTab).fadeIn();
			return false;
		});
	}

	function sliderVideo(){
		//Videos SLIDER
		new Swiper(".videos-swiper-container", {
			slidesPerView: "auto",
			spaceBetween: 10,
			// init: false,

			breakpoints: {
				640: {
					slidesPerView: "auto",
					spaceBetween: 20,
				},
				768: {
					slidesPerView: "auto",
					spaceBetween: 20,
				},
				1024: {
					slidesPerView: 5,
					spaceBetween: 40,
				},
			}
		});
	}
	function sliderSingleGallery(){
		//Single News SLIDER
		new Swiper(".single-gallery", {
			
			pagination: {
			  el: '.pagination',
			  clickable: true,
			},
			navigation: {
			  nextEl: '.button-next',
			  prevEl: '.button-prev',
			},
		
		});
	}

	function mobileOnlySlider(){
		//---------------------------- Mobile only SLIDERS
		// ImageBlocks + Portofolio
		// imgBlockBreakpoint where swiper will be destroyed and switches to a dual-column layout
		const imgBlockBreakpoint = window.matchMedia("(min-width:767px)");
		const portfolioBreakpoint = window.matchMedia("(min-width:769px)");
		let imgBlocksSwiper;
		let portofolioSwiper;
		const breakpointChecker = function () {
			// if larger viewport and multi-row layout needed
			// else if a small viewport and single column layout needed
			if (imgBlockBreakpoint.matches === true) {
				// replace swiper classes with grid
				$(".imgblocks-swiper-container .swiper-wrapper").addClass("row");

				// clean up old instances and inline styles when available
				// or/and do nothing
				if (imgBlocksSwiper !== undefined) imgBlocksSwiper.destroy(true, true);
			} else if (imgBlockBreakpoint.matches === false) {
				// replace grid classes with swiper
				$(".imgblocks-swiper-container .swiper-wrapper").removeClass("row");

				// fire small viewport version of swiper
				return enableImgBlockSwiper();
			}
		};

		const portfolioBreakpointChecker = function () {
			if (portfolioBreakpoint.matches === true) {
				// replace swiper classes with grid
				$(".portfolios .swiper-wrapper .swiper-slide").removeClass("swiper-slide").addClass("grid-item-wrapper");
				$(".portfolios .swiper-wrapper").removeClass("swiper-wrapper").addClass("grid-wrapper");

				// clean up old instances and inline styles when available
				// or/and do nothing
				if (portofolioSwiper !== undefined) portofolioSwiper.destroy(true, true);
			} else if (portfolioBreakpoint.matches === false) {
				// replace grid classes with swiper
				$(".portfolios .grid-wrapper .grid-item-wrapper").removeClass("grid-item-wrapper").addClass("swiper-slide");
				$(".portfolios .grid-wrapper").removeClass("grid-wrapper").addClass("swiper-wrapper");


				// fire small viewport version of swiper
				return enablePortfolioSwiper();
			}
		}
		const enableImgBlockSwiper = function () {
			imgBlocksSwiper = new Swiper(".imgblocks-swiper-container", {
				slidesPerView: 1,
				loop: false,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
			});
		};
		const enablePortfolioSwiper = function () {

			portofolioSwiper = new Swiper(".portfolios", {
				slidesPerView: "auto",
				spaceBetween: 10,
				initialSlide: 0,
				loop: false,
				// init: false,

				breakpoints: {
					640: {
						slidesPerView: 2,
						spaceBetween: 10,
						loop: false,
					},
					768: {
						centeredSlides: false,
						slidesPerView: 2,
						spaceBetween: 20,
						loop: false,
					},
					1024: {
						slidesPerView: 5,
						spaceBetween: 50,
					},
				}
			});
		};
		imgBlockBreakpoint.addListener(breakpointChecker); // keep an eye on viewport size changes
		breakpointChecker();
		portfolioBreakpoint.addListener(portfolioBreakpointChecker); // keep an eye on viewport size changes
		portfolioBreakpointChecker();
	}


    //=== Scroll Event
    window.addEventListener('scroll', function () {
        stickyHeader();
    });

    // === DOC READY ===
    $(function () {
    	oldBrowsers();
    	heroSlider();
		menuToggle();
		accordionsElement();
		tabsElement();
		sliderVideo();
		sliderSingleGallery();
		mobileOnlySlider();
    });

})(window.jQuery);